import axios from "axios";
import qs from 'qs';
import store from "../store";
import {Message} from "element-ui";

let baseUrl = "";
const TIME_OUT = 300000 // 超时时间300秒
switch (process.env.NODE_ENV) {
    case "development":
        baseUrl = "/api";
        break;
    case "production":
        baseUrl = process.env.VUE_APP_URL;
        break;
}
axios.defaults.baseURL = baseUrl;
let reqNum = 0;
axios.interceptors.request.use(config => {
    let params = config.method === "get" ? config.params : config.data;
    if (!reqNum && !params.isHideLoading) {
        store.state.showLoading = true;
    }
    reqNum++;
    return config;
});
axios.interceptors.response.use(
    data => {
        reqNum--;
        if (!reqNum) {
            store.state.showLoading = false;
        }
        if (data.data.errcode === -1) {
            Message.error({
                message: data.data.msg
            });
            return Promise.reject(data);
        }
        return data;
    },
    err => {
        reqNum--;
        if (!reqNum) {
            store.state.showLoading = false;
        }
        // Message.error({
        //     message: "请求失败！"
        // });
        return Promise.reject(err);
    }
);

const _request = (method, url, data) => {
    const headers = {}
    const configData = {
        url, // 请求的地址
        timeout: TIME_OUT, // 超时时间, 单位毫秒
        headers
    }
    method = method.toLowerCase();
    if (method === 'get') {
        configData.method = 'get'
        configData.params = data// get 请求的数据
    } else if (method==='post'||method==='postform') {
        configData.method = 'post'
        if (data instanceof FormData) {
            configData.headers['Content-Type'] = 'multipart/form-data; charset=UTF-8'
            configData.data = data
        } else {
            configData.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
            configData.data = qs.stringify(data)
        }
    } else if (method === 'postjson') {
        configData.method = 'post'
        configData.headers['Content-Type'] = 'application/json; charset=UTF-8'
        configData.data = data
    }

    return axios(configData)
}


export default function ajax(url = "", data = {}, type = "GET") {
    return new Promise(function (resolve, reject) {
        let promise;
        // if (store.state.ssid) {
        //     url += `?ssid=${store.state.ssid}`;
        // }
        promise = _request(type, url, data);
        promise.then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
}
export function downloadFile(url = "", data = {}) {
    return axios({
      url: url, //your url
      method: 'POST',
      params: data,
      responseType: 'blob', // important
    }).then(function (response) {
        console.log(response);
      const blob = new Blob(
          [response.data], { type: 'application/octet-stream;charset=utf-8' });
      const aEle = document.createElement('a');     // 创建a标签
      const href = window.URL.createObjectURL(blob);       // 创建下载的链接
      aEle.href = href;
      if(response.data.code){
          return;
      }
      aEle.download = getFilenameFromResponse(response);  // 下载后文件名
      document.body.appendChild(aEle);
      aEle.click();     // 点击下载
      document.body.removeChild(aEle); // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    });
  }
  
  function getFilenameFromResponse(response) {
    let filename = new Date().getMilliseconds() + ".xls";
    let disposition = response.headers["content-disposition"];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(disposition);
    if (matches != null && matches[1]) {
      filename = matches[1].replace(/['"]/g, '');
    }
    return filename;
  }
